<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

@if (properties?.length > 0) {
  <p-table #pt [value]="ownerStmtExps" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="ownerStmtExpId"
    selectionMode="single" [(selection)]="ownerStmtExp" (onRowSelect)="onRowSelect($event)" [loading]="loading"
    [paginator]="showPagination" [rows]="100" [rowsPerPageOptions]="[100,200,300,500]" showCurrentPageReport="true"
    currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
    sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
    [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
    <ng-template pTemplate="caption">
      <div class="d-block text-end justify-content-between align-items-center">
        @if (!ownerStmtId) {
          <h1 style="float: left;margin: 6px;">Owner Stmt Exp</h1>
        }
        <!-- <h5 *ngIf="ownerStmtId" style="float: left;margin: 6px;">Owner Stmt Exp</h5> -->
        <span>
          <!--clear filters-->
          @if (showFilter) {
            <button pButton pRipple class="p-button-text"
              style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
            (click)="reloadPage()">Clear Filters</button>
          }
          <!--add new-->
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Owner Stmt Exp+</button>
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        @for (col of columns; track col) {
          @if (col.showSort) {
            <th class="text-nowrap" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          } @else {
            <th class="text-nowrap">
              {{col.header}}
            </th>
          }
        }
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
      @if (showFilter) {
        <tr>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ownerStmtExpId', 'in')"></th>
          <th>
            <p-multiSelect dropdownIcon="fa fa-caret-down" #aa [style]="{'width':'50px','min-width':'100%'}" [(ngModel)]="shortTermRentalId"
              [options]="properties" appendTo="body" defaultLabel="Property Code"
              (onChange)="pt.filter($event.value, 'shortTermRentalId', 'in')" styleClass="p-column-filter"
              placeholder="Filter" [showClear]="true" optionLabel="propertyCode"
              optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false">
              <ng-template let-option pTemplate="item">
                <span>{{option.propertyCode}}</span>
              </ng-template>
            </p-multiSelect>
          </th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}">
            <p-calendar [(ngModel)]="expenseDateRange" appendTo="body" showButtonBar="true"
              selectionMode="range" placeholder="Select Date Range" (onClose)="onExpenseDateRangeChange()"
              [style]="{'width':'100%','min-width':'200px'}" dateFormat="mm-dd-yy">
            </p-calendar>
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <p-calendar [(ngModel)]="stmtBilledDateRange" appendTo="body" showButtonBar="true"
              selectionMode="range" placeholder="Select Date Range" (onClose)="onStmtBilledDateRangeChange()"
              [style]="{'width':'100%','min-width':'200px'}" dateFormat="mm-dd-yy">
            </p-calendar>
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <p-multiSelect dropdownIcon="fa fa-caret-down" [style]="{'width':'100%','max-width':'200px'}" [options]="ownerStmtService.expenseCategories" defaultLabel="Category" optionLabel="name"
            (onChange)="pt.filter($event.value, 'expenseCategory', 'in')" appendTo="body"></p-multiSelect>
          </th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'startDate', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'endDate', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
      }
    </ng-template>
    <ng-template pTemplate="body" let-ownerStmtExp>
      @if (!ownerStmtId || (ownerStmtId && ownerStmtId == ownerStmtExp.ownerStmtId)) {
        <tr [pSelectableRow]="ownerStmtExp">
          <td>{{ownerStmtExp.ownerStmtExpId}}</td>
          <td>{{getPropertyCode(ownerStmtExp?.shortTermRentalId)}}</td>
          <td [pTooltip]="ownerStmtExp.name" tooltipPosition="top">{{ownerStmtExp.name}}</td>
          <td>{{toLocal(ownerStmtExp.expenseDate) | date:'MM-dd-yyyy'}}</td>
          <td>{{toLocal(ownerStmtExp.stmtBilledDate) | date:'MM-dd-yyyy'}}</td>
          <td>{{getExpenseCategory(ownerStmtExp)}}</td>
          <td>{{ownerStmtExp?.expenseAmount | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.paidByKbm | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.paidByOwner | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.materialsPaidByKbm | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.materialsPaidByOwner | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.laborPaidByKbm | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.laborPadiByOwner | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.thirdPartExpensePaidByKbm | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.thirdPartExpensePaidByOwner | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.taxPaidByKbm | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.taxPadiByOwner | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.miscPaidByKbm | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{ownerStmtExp?.miscPaidByOwner | currency:'USD':'symbol':'1.2-2'}}</td>
          <td>{{toLocal(ownerStmtExp.startDate) | date:'MM-dd-yyyy'}}</td>
          <td>{{toLocal(ownerStmtExp.endDate) | date:'MM-dd-yyyy'}}</td>
          <td><span style="float:none">
            <a>
              <i class="pi pi-pencil" aria-hidden="true"
                style="color:blue; font-size:110%; padding-right:20px;"
              (click)="onOpenFormEdit(ownerStmtExp)"></i>
            </a>
          </span>
        </td>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="columns.length + 1" class="text-center fw-bold p-2">
        {{loading ? 'Loading Expenses...' : 'No Expenses Found'}}
      </td>
    </tr>
  </ng-template>
</p-table>
}